import type { CanalNotificacion, EstadoNotificacion } from "@copi/shared";

import { apiClient } from "./client";
import { unwrap } from "./unwrap";

export interface NotificacionWire {
  id: string;
  expedienteId: string | null;
  usuarioDestinoId: string;
  tipoEvento: string;
  canal: CanalNotificacion;
  asunto: string;
  contenido: string;
  estado: EstadoNotificacion;
  intentoEnvio: number;
  enviadaEn: string | null;
  leidaEn: string | null;
  fechaCreacion: string;
}

export const notificacionesApi = {
  /** Lista las notificaciones no leídas del usuario autenticado. */
  mias(): Promise<NotificacionWire[]> {
    return apiClient.get("/notificaciones/mias").then(unwrap<NotificacionWire[]>);
  },
  /** Marca una notificación como leída (idempotente). */
  marcarLeida(id: string): Promise<void> {
    return apiClient
      .patch(`/notificaciones/${id}/marcar-leida`, {})
      .then(unwrap<{ ok: true }>)
      .then(() => undefined);
  },
};
